import { AfterViewInit, Component, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';
import { StationMap, StationItem } from '../../models/station';
import { StationService } from '../../services/station.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as L from 'leaflet';

import { DEFAULT_LAT, DEFAULT_LONG } from '../../constants';
import { AttachmentPoint } from '../../models/attachmentpoint';
import { Group } from '../../models/group';
import { AttachmentPointService } from '../../services/attachment-point.service';
import { GroupService } from '../../services/group.service';
import { NominatimService } from '../../services/utils/nominatim.service';
import { ToastsManager } from 'ng2-toastr';
import { Geopoint } from '../../models/geopoint';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

declare var $: (target: string) => any;

@Component({
  selector: 'app-station-form',
  templateUrl: './station-form.component.html',
  styleUrls: ['./station-form.component.css'],
})
export class StationFormComponent implements OnInit, AfterViewInit {

  /** Indicates whether we are in creation or update mode */
  creationMode: boolean;

  /** Binded model */
  station: StationItem;

  /** leaflet options */
  options = {
    layers: [
      L.tileLayer(environment.osmUrl,
        { maxZoom: 18, attribution: 'Open Street Map' })
    ],
    zoom: 10,
    center: L.latLng(DEFAULT_LAT, DEFAULT_LONG)
  };

  /* binded map properties */
  center: L.LatLng = this.options.center;
  zoom: number = this.options.zoom;

  /** markers to display on map array */
  markers: any[] = [];

  selectedAPIds: any;
  selectedAPFreeIds: any;

  selectedAPFree: any;
  selectedAP: any;

  selectedGroup: Group;
  groups: Group[];
  apLight: AttachmentPoint[];

  /** Non bind to station attachment points from selected group (no subgrp) */
  apLightFree: AttachmentPoint[];

  from: AttachmentPoint[];
  to: AttachmentPoint[];

  freeAPLoaded = false;
  linkedAPLoaded = false;

  /** Location SEARCH */
  placeToSearch: string;

  /**
   * Output to signal the creation or update of an station
   * It will allow us to add or update the line in the table of all stations.
   */
  @Output() onUpdateValidation = new EventEmitter<StationItem>();
  @Output() onCreateValidation = new EventEmitter<boolean>();

  constructor(private stationService: StationService,
    public activeModal: NgbActiveModal,
    private apService: AttachmentPointService,
    private groupService: GroupService,
    private renderer: Renderer2,
    private geoService: NominatimService,
    public toastManager: ToastsManager,
    public translate: TranslateService) {
  }

  ngOnInit() {
    // list of groups to display
    this.groupService.loadVisibleGroups().subscribe(groups => {
      this.groups = groups;
    });

    if (this.creationMode) {
      this.station.location = new Geopoint();
      this.centerMap();
      this.freeAPLoaded = true;
      this.linkedAPLoaded = true;
    } else {
      this.displayMarker(this.station.location.latitude, this.station.location.longitude);

      // load AP attached to this station
      this.apService.getAPAttachedtoStation(this.station.id).subscribe(res => {
        this.apLight = res.res;
        this.linkedAPLoaded = true;
      });

      // loads available AP for this group
      this.apService.getFreeAPByGroup(this.station.groupId).subscribe(res => {
        this.apLightFree = res.res;
        this.freeAPLoaded = true;
      });
    }
  }

  /**
   * Load AP of the group
   */
  selectedGroupChanged() {
    // loading ap related to stations
    this.freeAPLoaded = false;
    this.apService.getFreeAPByGroup(this.station.groupId).subscribe(res => {
      this.apLightFree = res.res;
      this.freeAPLoaded = true;
    });

  }

  ngAfterViewInit() {
    $('#lstview').multiselect();
  }

  /**
   * Create or update user profile calling services
   */
  submit(): void {
    this.save();
    // submit changes
    if (this.creationMode) {
      this.stationService.create(this.station).subscribe(sta => {
        this.toastManager.success(this.translate.instant('toast.stationcreated'), this.translate.instant('toast.success'));
        this.onCreateValidation.emit(true);
      });
    } else {
      this.stationService.update(this.station).subscribe(sta => {
        this.onUpdateValidation.emit(sta);
        this.toastManager.success(this.translate.instant('toast.stationupdated'), this.translate.instant('toast.success'));

      });
    }

    this.activeModal.close(null);
  }

  save() {
    // Retrieve ids (right panel)
    this.station.attachmentPointIds = new Array();
    const that = this;
    const indexes_to = $('#lstview_to option').map(function () {
      that.station.attachmentPointIds.push(parseInt($(this).val().split(':')[1], 10));
    });
  }

  /**
  * Center map :
  * If center isn't stored in the local storage => center the map to fit all stations
  * Else center with previously stored information
  */
  centerMap(): void {

    if (localStorage.getItem('lastDashboardCenter')) {
      this.center = JSON.parse(localStorage.getItem('lastDashboardCenter'));
      this.zoom = JSON.parse(localStorage.getItem('lastDashboardZoom'));
    } else {
      const coordinatesList: L.LatLng[] = [];
      coordinatesList.push(L.latLng(DEFAULT_LAT, DEFAULT_LONG));
    }

  }

  searchLocation(): void {
    this.geoService.search(this.placeToSearch).subscribe(res => {
      if (res.length === 0) {
        this.toastManager.warning(this.translate.instant('toast.locationNotFound'), this.translate.instant('toast.locationErr'));
      } else {
        this.station.location.latitude = res[0].lat;
        this.station.location.longitude = res[0].lon;
        this.displayMarker(res[0].lat, res[0].lon);
        this.zoom = 15;
      }
    });
  }

  /**
   * Display a marker that can be dragged throught the map
   * Its coordinates are bind with this.station.location
   */
  displayMarker(lat, long) {
    this.markers = [];
    const newMarker = L.marker([lat, long],
      {
        draggable: true,
        icon: L.icon({
          iconSize: [41, 51],
          iconAnchor: [20, 51],
          popupAnchor: [0, -51],
          iconUrl: '/assets/marker_100.png'
        })
      }
    );

    const that = this;
    newMarker.on('dragend', function (e) {
      const coord = String(newMarker.getLatLng()).split(',');
      that.station.location.latitude = parseFloat(coord[0].split('(')[1]);
      that.station.location.longitude = parseFloat(coord[1].split(')')[0]);
    });

    this.markers.push(newMarker);
    this.center = L.latLng(lat, long);
  }

}



// WEBPACK FOOTER //
// ./src/app/stations/station-form/station-form.component.ts